import { Stack, Typography } from "@mui/material";
import { FunctionComponent } from "react";

import { FAQ } from "../types/faq";

interface Props {
  faq: FAQ;
}

const FAQCard: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { faq } = props;

  return (
    <Stack sx={{ pb: 6 }}>
      <Typography
        variant="h6"
        sx={{
          wordBreak: 'break-word',
          hyphens: 'auto',
        }}
      >
        {faq.question}
      </Typography>
      <Typography
        variant="body1"
        component={"div"}
        sx={{
          wordBreak: 'break-word',
          hyphens: 'auto',
        }}
        dangerouslySetInnerHTML={{
          __html: faq.answer,
        }}
      />
    </Stack>
  );
};

export default FAQCard;
